import UnderConstruction from '../components/UnderConstruction'

const Games = () => {
    return (
        <UnderConstruction/>
    );
}

export default Games;